/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerLimits } from '../../models/customer-limits';

export interface GetDkvLimits$Params {

/**
 * UUID to identify the svg (tenancy id)
 */
  svgId: string;

/**
 * UUID to identify the customer
 */
  customerId: string;

/**
 * customer number from dkv, foreign tenancy id
 */
  dkvCustomerNumber: string;
}

export function getDkvLimits(http: HttpClient, rootUrl: string, params: GetDkvLimits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerLimits>> {
  const rb = new RequestBuilder(rootUrl, getDkvLimits.PATH, 'get');
  if (params) {
    rb.path('svgId', params.svgId, {});
    rb.path('customerId', params.customerId, {});
    rb.path('dkvCustomerNumber', params.dkvCustomerNumber, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerLimits>;
    })
  );
}

getDkvLimits.PATH = '/svgs/{svgId}/customers/{customerId}/limits-config/{dkvCustomerNumber}';
